<template>
    <span
        :class="{
            tag: true,
            'tag--competency': tag.type === 'competence',
        }"
    >
        {{ tag.name }}
    </span>
</template>

<script>
export default {
    name: 'Tag',
    props: {
        tag: {
            type: Object,
            default: () => {},
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';
@import 'src/styles/variables';

.tag {
    border-radius: urem(10);
    font-size: urem(10);
    font-weight: 500;
    line-height: urem(18);
    background-color: rgba(236, 239, 247, 1);
    color: rgba(70, 99, 171, 1);
    padding: urem(2) urem(5);

    
    display: flex;
    align-items: center;
    justify-content: center;

    flex: 0 0 auto;
    width: fit-content;
    height: fit-content;
    min-height: urem(22);

    &--competency {
        background-color: rgba(240, 239, 245, 1);
        color: rgba(105, 96, 159, 1);
    }

    max-width: urem(300);

    @include on-desktop {
        max-width: urem(200);
    }
}
</style>
